// extracted by mini-css-extract-plugin
export default {"heroGradientText":"heroBannerStyles_heroGradientText__7AwZo"};